import { ChangeDetectionStrategy, Component, Input, TemplateRef } from '@angular/core';
import { AppLoaderConfig, IAppLoaderConfig } from '../../interfaces';

@Component({
  selector: 'loading-spinner',
  templateUrl: './loading-spinner.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LoadingSpinnerComponent {
  @Input() public show: boolean;
  @Input() public config: IAppLoaderConfig = new AppLoaderConfig();
  @Input() public template!: TemplateRef<any>;
  @Input() public isAPIBased: boolean;
}
